// extracted by mini-css-extract-plugin
module.exports = {"published-wrapper":"_1Kp4J","title":"D72CL","date":"_20W6_"};